export const PARTNER_BUCKET = 'checklist-partner-media';
export const MAX_PARTNER_MEDIA_BYTES = 10 * 1024 * 1024;
export const partnerMediaMime = (bytes: Uint8Array): string | null => {
  if (bytes.length >= 3 && bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) return 'image/jpeg';
  if (bytes.length >= 8 && [137,80,78,71,13,10,26,10].every((value,index) => bytes[index] === value)) return 'image/png';
  if (bytes.length >= 12 && String.fromCharCode(...bytes.slice(0,4)) === 'RIFF' && String.fromCharCode(...bytes.slice(8,12)) === 'WEBP') return 'image/webp';
  return null;
};
export const parsePartnerStorageRef = (value: unknown): string | null => {
  if (typeof value !== 'string') return null;
  const prefix = `storage://${PARTNER_BUCKET}/`;
  if (!value.startsWith(prefix)) return null;
  const path = value.slice(prefix.length);
  return /^[0-9a-f-]{36}\/[0-9a-f-]{36}\/[0-9a-f-]{36}\.(jpg|png|webp)$/.test(path) ? path : null;
};

/** Ajusta somente a origem de URLs que o próprio Storage assinou para o ambiente local/proxy. */
export const partnerSignedStorageUrl = (signedUrl: string, configuredBase?: string): string => {
  if (!configuredBase) return signedUrl;
  const base = new URL(configuredBase);
  if (base.username || base.password || base.search || base.hash || base.pathname !== '/' ||
      (base.protocol !== 'https:' && !(base.protocol === 'http:' && ['localhost','127.0.0.1','[::1]'].includes(base.hostname)))) {
    throw new Error('partner_storage_base_invalid');
  }
  const signed = new URL(signedUrl);
  if (!signed.pathname.startsWith('/storage/v1/')) throw new Error('partner_storage_signed_url_invalid');
  return `${base.origin}${signed.pathname}${signed.search}${signed.hash}`;
};
